export default "__VITE_ASSET__DrezqIhT__"